import styled from '@emotion/styled'

export const StoreOpeningDialogWrapper = styled.div`
  hexa-v2-dialog::part(header) {
    font-weight: var(--font-weight-semi-bold);
    font-size: var(--fontsize-6);
    line-height: var(--lineheight-7);
    letter-spacing: var(--space-0);
  }

  hexa-v2-dialog::part(wrapper) {
    width: 328px;
  }

  @media (min-width: 768px) {
    hexa-v2-dialog::part(wrapper) {
      width: 600px;
    }
  }
`

export const containerStyles = {
  container: {
    flexDirection: 'column',
    gap: 'var(--space-4)',
  },
}

export const buttonStyles = {
  container: {
    justifyContent: 'flex-end',
    gap: 'var(--space-4)',
  },
}

export const ErrorContainer = styled.div`
  hexa-v2-text::part(text) {
    color: var(--foundation-txt-error);
  }
`
